import { ArrowCircleDown2 } from 'iconsax-react';
import DocumentIcon from '@/assets/images/icons/document.svg?react';
import AnchorLink from '@/components/common/anchor-link';
import useConversationStore, { useConversationHandlers } from '@/hooks/conversations/use-conversation-store';
import useDownloadMessageFile from '@/hooks/use-download-message-file';
import useUserPlatform from '@/hooks/use-user-platform';
import { getMessageDownloadParams } from '@/utils/get-message-downloadable';
import cn from '@/utils/merge-class-names';
import type { ContentCommonProps } from './content-common-props';
import { MessageQuote } from './message-quote';
export default function ContentFile({ message, className }: ContentCommonProps) {
  const { url: externalFileUrl, key: filename } = getMessageDownloadParams(message) || {};
  const { resetSelectedMessages } = useConversationStore();
  const { handleInteraction: onInteraction } = useConversationHandlers();
  const { isIOS, isStandalone, isEmbedded } = useUserPlatform();
  const { isDownloading, handleDownload } = useDownloadMessageFile(message);
  const handleViewFile = () => {
    resetSelectedMessages([message]);
    onInteraction('preview');
  };

  return (
    <div className='chat-bubble min-w-min group-data-receiver:chat-bubble-plain group-data-sender:chat-bubble-primary flex-row flex items-center gap-x-2'>
      {message.Quote && (
        <MessageQuote
          className='py-1.5 px-2 mb-1 w-full'
          quote={message.Quote}
        />
      )}
      <div className={cn('min-w-0 before:hidden max-w-[calc(80vw-80px)] flex gap-x-2 items-center', className)}>
        <div className='mx-auto flex h-full max-w-full items-center gap-2 rounded-md px-2 py-1 group-data-sender:theme-ryuryu:bg-blue-300 group-data-sender:theme-wangyou:bg-teal-200 group-data-sender:theme-threetwoone:bg-purple-100 group-data-sender:theme-eightk:bg-purple-100 group-data-sender:theme-bonglan:bg-red-300 group-data-sender:theme-kbar:bg-red-300 group-data-sender:text-body bg-base-100 text-body'>
          <div className='relative flex min-w-0 max-w-full flex-1 items-center gap-2'>
            <DocumentIcon className='size-6' />
            <p className='font-mono line-clamp-2 break-all text-body1 desktop:text-h3'>{filename}</p>
            <button
              type='button'
              className='absolute inset-0 z-10 flex cursor-pointer items-end justify-end rounded-lg data-quote:hidden'
              onClick={handleViewFile}
            />
          </div>
        </div>
      </div>
      {isIOS && isStandalone && !isEmbedded ? (
        externalFileUrl && (
          <AnchorLink
            direct
            href={externalFileUrl}>
            <ArrowCircleDown2
              variant='Bold'
              className='text-primary'
            />
          </AnchorLink>
        )
      ) : (
        <button
          type='button'
          className='btn btn-circle size-6 btn-ghost min-h-6'
          disabled={isDownloading}
          onClick={handleDownload}>
          {isDownloading ? (
            <span className='loading loading-spinner loading-sm' />
          ) : (
            <ArrowCircleDown2
              variant='Bold'
              className='text-primary'
            />
          )}
        </button>
      )}
    </div>
  );
}
